import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { toast } from 'sonner';
import { Shield, Lock } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const AdminLogin = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    
    if (!email || !password) {
      toast.error('Please fill all fields');
      return;
    }

    setLoading(true);
    try {
      await axios.post(`${API}/admin/login`, { email, password }, { withCredentials: true });
      // Session is stored in httpOnly cookie by the backend - no localStorage needed for security
      toast.success('Admin login successful');
      navigate('/admin/dashboard');
    } catch (error) {
      console.error('Admin login error:', error);
      toast.error(error.response?.data?.detail || 'Invalid credentials');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-900 flex items-center justify-center p-4">
      <div className="bg-white border border-slate-200 p-8 w-full max-w-md" data-testid="admin-login-page">
        <div className="text-center mb-8">
          <div className="w-16 h-16 bg-slate-900 mx-auto mb-4 flex items-center justify-center">
            <Shield className="w-8 h-8 text-white" />
          </div>
          <h1 className="font-display text-2xl font-bold text-slate-900">Admin Login</h1>
          <p className="text-slate-500 text-sm mt-1">My Detective Admin Panel</p>
        </div>

        <form onSubmit={handleLogin} className="space-y-4">
          <div>
            <label className="text-xs tracking-[0.2em] uppercase font-bold text-slate-500 mb-2 block">
              Email
            </label>
            <Input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="admin@ourinvestigator.com"
              className="rounded-none border-slate-200"
              data-testid="admin-email-input"
            />
          </div>

          <div>
            <label className="text-xs tracking-[0.2em] uppercase font-bold text-slate-500 mb-2 block">
              Password
            </label>
            <Input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              className="rounded-none border-slate-200"
              data-testid="admin-password-input"
            />
          </div>

          <Button 
            type="submit"
            disabled={loading}
            className="w-full rounded-none bg-slate-900 text-white hover:bg-slate-800 h-11"
            data-testid="admin-login-btn"
          >
            {loading ? (
              <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" />
            ) : (
              <>
                <Lock className="w-4 h-4 mr-2" />
                Login to Admin Panel
              </>
            )}
          </Button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
